import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, manageActions } from '../../../store/actions'
import Input from '../../../module/input/CustomInput'
import { validCompanyInfo } from '../../../hook/valid/companyInfo'
import Alert from '../../../module/alert/Alert'

const ManageInfo = (props) => {
  const [state, setState] = useState({
    // isView: false
    groupName: '', // 사업자/단체명
    rprsntvNm: '', // 대표자명
    groupRegistno: '', // 사업자등록번호
    description: '', // 비고
  })

  useEffect(() => {
    props.getGroupInfo()
  }, [])

  // 초기 사업자 정보 조회 성공 후
  useEffect(() => {
    setState({
      ...state,
      ...props.groupInfo,
    })
  }, [props.isSearch])

  // 사업자 정보 변경 성공 후
  useEffect(() => {
    if (props.isUpdate) {
      // 사용자정보 변경 성공
      props.success({
        title: '성공',
        message: '수정되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            //props.getGroupInfo();
            window.location.reload()
          },
        },
      })
    } else {
      // 변경 실패
    }
  }, [props.isUpdate])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const setGroupInfo = (e) => {
    e.preventDefault()

    // 유효성 체크
    // 1. 필수값 체크
    if (props.checkFindInput(state)) {
      props.confirm({
        title: '확인',
        message: '저장하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.setGroupInfo(state) // 사업자 정보 변경
          },
        },
      })
    }
  }

  return (
    <div id="contents">
      {/* <Alert /> */}
      <div className="content-header">
        {/* mobile 뒤로가기 버튼 */}
        <a
          onClick={(e) => {
            e.preventDefault()
            window.history.back()
          }}
          className="page-prev"
        >
          뒤로이동
        </a>
        <h2>사업자 관리</h2>
        <div className="breadcrumb">
          <span>Home</span>
          <span>마이페이지</span>
          <em>사업자 관리</em>
        </div>
      </div>
      <h3 className="h3-tit mt0">사업자 정보</h3>
      <p className="required">* 표시는 필수 입력사항입니다.</p>
      <table className="tbl-write">
        <caption>사업자/단체명, 대표자명, 사업자등록번호, 비고 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              <em className="required" /> 사업자/단체명
            </th>
            <td>
              <Input
                inputTitle="사업자/단체명"
                type={'text'}
                id="groupName"
                name="groupName"
                value={state.groupName || ''}
                className="form-control input-text"
                placeholder="사업자/단체명"
                onChange={(e) => handleChange(e)}
                required={true}
                numberOnly={false}
                flow={'left'}
                length={30}
              />
            </td>
            <th scope="row">
              <em className="required" /> 대표자명
            </th>
            <td>
              <Input
                inputTitle="대표자명"
                type={'text'}
                id="rprsntvNm"
                name="rprsntvNm"
                //value={this.state.company['company'].data ? this.state.company['company'].data['rprsntvNm'] : ''}
                value={state.rprsntvNm || ''}
                className="form-control input-text"
                placeholder="대표자명"
                onChange={(e) => handleChange(e)}
                required={true}
                numberOnly={false}
                flow={'left'}
                length={100}
              />
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 사업자등록번호
            </th>
            <td colSpan={3}>
              {/* <input type="text" value="1234567890" class="form-keyword" readonly> */}
              <Input
                inputTitle="사업자등록번호"
                type={'text'}
                id="groupRegistno"
                name="groupRegistno"
                className="form-keyword disabled"
                placeholder="사업자등록번호"
                value={state.groupRegistno || ''}
                required={true}
                readOnly={true}
              />
            </td>
          </tr>
          <tr>
            <th scope="row">비고</th>
            <td colSpan={3}>
              <textarea
                title="비고"
                className="form-control input-textarea"
                name="description"
                id="description"
                value={!state.description || state.description == 'null' ? '' : state.description}
                onChange={(e) => handleChange(e)}
                rows={10}
                placeholder="내용을 입력해주세요."
                length={1000}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="btn-block">
        <span className="right">
          <a className="btn-secondary md" onClick={() => window.history.back()}>
            취소
          </a>
          <a className="btn-primary md" onClick={setGroupInfo}>
            저장
          </a>
        </span>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    address: state.manage?.address,
    groupInfo: state.manage?.data,
    isSearch: state.manage?.isSearch,
    isUpdate: state.manage?.isUpdate,
  }
}

const actionCreators = {
  getGroupInfo: manageActions.getGroupInfo,
  setGroupInfo: manageActions.setGroupInfo,
  checkFindInput: validCompanyInfo.checkFindInput,
  confirm: alertActions.confirm,
  success: alertActions.success,
}

export default connect(mapStateToProps, actionCreators)(ManageInfo)
